import { render, staticRenderFns } from "./LisaMarieBarber.vue?vue&type=template&id=67457206&"
import script from "./LisaMarieBarber.vue?vue&type=script&lang=js&"
export * from "./LisaMarieBarber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports